import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CLEVERCHANNEL, GOOGLE_CLASSROOM_CHANNEL, SIGN_IN_STATE, STUDENT, TEACHER } from '../../constants'
import _ from 'lodash'
import { setSignInState } from '../../redux/Dashboard/UserReducer'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

const RoutingController = () => {
  const { user, isLoggedIn, ageGate } = useSelector(state => state.authentication)
  const dispatch = useDispatch()
  const history = useHistory()

  const changeStateAndGo = (nextState) => {
    dispatch(setSignInState(nextState))
    history.push(`/signup/${nextState}`)
  }

  useEffect(() => {
    if (!isLoggedIn) return
    if (user?.guardianEmail !== null) return
    if (user?.persona === STUDENT && (user?.rosters.length > 0 || user?.memberships?.length > 0)) return
    // Done as else if statements so that we check things in order, we don't want to popup several modals to the user at once
    if (user && _.isEmpty(user?.persona)) {
      changeStateAndGo(SIGN_IN_STATE.SSO_CHOOSE_ROLE)
    } else {
      // prevents checks while user state is updating
      if (user) {
        if (user?.persona === STUDENT) {
          if (user.registrationChannel !== GOOGLE_CLASSROOM_CHANNEL && user.registrationChannel !== CLEVERCHANNEL) {
            if (user?.ageOfConsent === null) {
              changeStateAndGo(SIGN_IN_STATE.AGE_GATE)
            } else {
              if (ageGate) {
                if (user?.ageOfConsent && isMissingStandardInfo()) {
                  changeStateAndGo(SIGN_IN_STATE.MISSING_INFO)
                }
              }
            }
          }
        } else if (isMissingStandardInfo() || isMissingSignature()) {
          changeStateAndGo(SIGN_IN_STATE.MISSING_INFO)
        } else if (user?.persona === TEACHER && _.isEmpty(user?.vpcSchool)) {
          changeStateAndGo(SIGN_IN_STATE.MISSING_INFO)
        } else if (_.isEmpty(user?.confirmedAt)) {
          changeStateAndGo(SIGN_IN_STATE.VERIFY_EMAIL)
        }
      }
    }
  }, [isLoggedIn, user?.persona, user?.ageOfConsent, user?.confirmedAt])

  const isMissingSignature = () => {
    return _.isEmpty(user.preferences.signature)
  }

  const isMissingStandardInfo = () => {
    if (user && user?.preferences) {
      return !user.preferences.toc || !user.preferences.privacyPolicy || _.isEmpty(user.username) || _.isEmpty(user.firstName)
    }
    return true
  }
  return (
    <></>
  )
}

export default RoutingController
